import { appendToDom, getBookieData } from '../utils'
import { createBookieListEl } from './create'
import * as order from './order'

document.addEventListener('DOMContentLoaded', async () => {
  const bookieListsWrapper = document.getElementById('bookie-list')

  if (!bookieListsWrapper) {
    return
  }

  const bookies = await getBookieData()
  const bookieList = createBookieListEl(bookies, 'order', false, 'sports')
  appendToDom(bookieListsWrapper, bookieList)

  const sortBookieTable = (e) => {

    const button = e.target
    const isDesc = 'desc' === button.dataset.order
    const market = button.dataset.market || ''
    const orderby = button.dataset.orderby
    const bookieList = createBookieListEl(bookies, orderby, isDesc, market)

    appendToDom(bookieListsWrapper, bookieList)
    order.setMarkets(market)
    order.setArrows(button, isDesc)
    order.setHighlights(button, orderby)
  }

  document.querySelectorAll('button[data-orderby]')
    .forEach(button => button.addEventListener('click', sortBookieTable))
})
